import React from 'react';

const WorkProcessSeven = () => {
  return (
    <>
      {/*==================== Work Process start ====================*/}
      <div className="work-process-area pd-top-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-8">
              <div className="section-title text-center">
                <h6 className="bg-none color-base mb-3">OUR SIMPLE PROCESS</h6>
                <h2 className="title">
                  Some of our Finished Projects That will Amaze Your Industry
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-work-process-inner-5 text-center">
                <div className="thumb block mb-3">
                  <img src="assets/img/home-7/7.png" alt="img" />
                  <p className="process-count">01</p>
                </div>
                <div className="details">
                  <h5 className="mb-3">Complete Online Form</h5>
                  <p className="content">
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-work-process-inner-5 text-center">
                <div className="thumb block mb-3">
                  <img src="assets/img/home-7/8.png" alt="img" />
                  <p className="process-count">02</p>
                </div>
                <div className="details">
                  <h5 className="mb-3">Documents &amp; Payments</h5>
                  <p className="content">
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-work-process-inner-5 text-center">
                <div className="thumb block mb-3">
                  <img src="assets/img/home-7/9.png" alt="img" />
                  <p className="process-count">03</p>
                </div>
                <div className="details">
                  <h5 className="mb-3">Receive Your Visa</h5>
                  <p className="content">
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking{' '}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ==================== Work Process Three end ====================*/}
    </>
  );
};

export default WorkProcessSeven;
